module.exports = __webpack_public_path__ + "static/IBMPlexSans-SemiBoldItalic-c845469a8fc5c0d543ad09656bc17c5f.woff2";